export type ProtocolInformation = {
  href: string;
  endpointProtocol?: string;
  endpointProtocolVersion?: Array<string>;
  subprotocol?: string;
  subprotocolBody?: string;
  subprotocolBodyEncoding?: string;
  securityAttributes?: Array<ProtocolInformationSecurityAttributes>;
};

export type ProtocolInformationSecurityAttributes = {
  type: ProtocolInformationSecurityAttributeTypes;
  key: string;
  value: string;
};

export enum ProtocolInformationSecurityAttributeTypes {
  NONE = 'NONE',
  RFCTLSA = 'RFC_TLSA',
  W3CDID = 'W3C_DID',
}
